import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SuccessStoriesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentStory, setCurrentStory] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const successStories = [
    {
      id: 1,
      name: "Sophia’s Testimonial",
      course: "App Development",
      duration: "6 months",
      beforeRole: "Final Year B.Tech Student",
      afterRole: "App Development",
      beforeSalary: "₹0",
      afterSalary: "₹8.5 LPA",
      salaryIncrease: "New Career",
      avatar: "",
      company: "TCS",
      companyLogo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
      location: "Bangalore",
      testimonial: `I joined the app development course with no prior knowledge and gradually understood the core concepts step by step. My trainer guided me well, addressing my difficulties and making each topic clear. Through the course, I also contributed to an internship in the content writing team, where I learned to apply concepts, use AI tools, and deliver reports on time. This journey helped me grow from basics to deeper understanding, and I’m grateful for the structured learning and support. Thanks for NIPIX Technology!`,
      videoThumbnail: "/assets/images/sophiya_thumbnail.png",
      videoUrl: "/sophiya.mp4", // Example MP4
      skills: ["Dart Programming", "Flutter Framework", "Firebase"],
      projects: [
        "E commerce App",
        "To do App",
        "Chat App"
      ],
      timeline: "Applied → 3 month course training → 6 months internship"
    },
    {
      id: 2,
      name: "Karthick & Dayanathi's Testimonial",
      age: 22,
      course: "Value Added Course in Embedded System and IoT",
      duration: "4 months",
      beforeRole: "Commerce Graduate",
      afterRole: "Value Added Course in Embedded System and IoT",
      beforeSalary: "₹0",
      afterSalary: "₹6.2 LPA",
      salaryIncrease: "Career Switch",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      company: "Zomato",
      companyLogo: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=100&h=100&fit=crop",
      location: "Gurgaon",
      testimonial: `The Value Added Course was an excellent learning experience — both interactive and practical. With the guidance of our trainers, my team and I developed a Car Parking System project and proudly won first prize. The unique token reward system kept us motivated throughout, and the sessions were engaging, well-structured, and easy to follow. It was one of the best learning experiences we’ve had, and we look forward to more such courses. Thanks for NIPIX Technology!`,
      videoThumbnail: "/assets/images/karthick_thumbnail.png",
      videoUrl: "/Karthick and dayanathi.mp4",
      skills: ["Embedded System", "Arduino Programming", "IoT"],
      projects: [
        "Smart Car Parking System", 
      ],
      timeline: "Applied → 5 Days value added course → Final project"
    },
    {
      id: 3,
      name: "Jenewar's Testimonial",
      age: 23,
      course: "Value Added Course in Embedded System and IoT",
      duration: "6 months",
      beforeRole: "Final Year B.Tech Student",
      afterRole: "Value Added Course in Embedded System and IoT",
      beforeSalary: "₹0",
      afterSalary: "₹8.5 LPA",
      salaryIncrease: "New Career",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
      company: "TCS",
      companyLogo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
      location: "Bangalore",
      testimonial: `From the very first day, learning with Nipix Technology was an extraordinary experience. The sessions were interactive, activity-based, and full of fun, ensuring that no one ever felt left out. Each day introduced us to new concepts and domains, which I initially thought might be dry, but they turned out to be highly engaging and practical. The hands-on approach made the learning journey both exciting and rewarding. Thanks for NIPIX Technology!`, 
      videoThumbnail: "/assets/images/jenewer_thumbnail.png",
      videoUrl: "/jenewer.mp4",
      skills: ["Embedded System", "Arduino Programming", "IoT"],
      projects: [
        "Smart Alert System",
      ],
      timeline: "Applied → 5 Days value added course → Final project"
    },
    {
      id: 4,
      name: "Dharani's Testimonial",
      age: 23,
      course: "Machine Learning Internship",
      duration: "6 months",
      beforeRole: "Final Year B.Tech Student",
      afterRole: "Machine Learning",
      beforeSalary: "₹0",
      afterSalary: "₹8.5 LPA",
      salaryIncrease: "New Career",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
      company: "TCS",
      companyLogo: "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop",
      location: "Bangalore",
      testimonial: `This is not just about receiving a certificate — it has been an experience where I truly felt comfortable and supported throughout my learning journey. The environment made me feel at ease, and I could focus on growing step by step. If you decide to join, you will find this platform to be more than just a course; it is a space to share your thoughts, gain knowledge, and build your skills with confidence. It has been a wonderful opportunity for me, and I am thankful for the guidance and support provided. Thanks for NIPIX Technology!`,
      videoThumbnail: "/assets/images/dharani_thumbnail.png",
      videoUrl: "/dharani.mp4", // Example MP4
      skills: ["Python", "TensorFlow", "Data Science", "Deep Learning"],
      projects: [
        "Prompt to image Generation"
      ],
      timeline: "Applied → 1 month training → 6 months internship"
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const element = document.getElementById('success-stories');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

//  useEffect(() => {
  //  if (isVisible && !isPlaying) {
    //  const interval = setInterval(() => {
      //  setCurrentStory((prev) => (prev + 1) % successStories.length);
     // }, 8000);
     // return () => clearInterval(interval);
   // }
 // }, [isVisible, isPlaying]);

  const handleStoryChange = (index) => {
    setCurrentStory(index);
    setIsPlaying(false);
  };

  const currentStudent = successStories[currentStory];

  return (
    <section id="success-stories" className="py-20 bg-gradient-to-b from-surface to-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-6">
            <span className="text-nipix-blue">R</span>
            <span className="text-text-primary">eal </span>
            <span className="text-nipix-blue">S</span>
            <span className="text-text-primary">tudents, </span>
            <span className="text-nipix-blue">R</span>
            <span className="text-text-primary">eal </span>
            <span className="text-nipix-blue">S</span>
            <span className="text-text-primary">uccess</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
            See how our students transformed their careers from theory to practice, landing dream jobs at top companies with significant salary increases.
          </p>
        </motion.div>

        {/* Main Story Display */}
        <motion.div
          key={currentStory}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-3xl shadow-2xl border border-border overflow-hidden mb-12"
        >
          <div className="grid lg:grid-cols-2 gap-0">
            {/* Story Content */}
            <div className="p-8 lg:p-12">
              {/* Student Info */}
              <div className="flex items-center space-x-4 mb-6">
                {/*<div className="relative">
                  <Image
                    src={currentStudent.avatar}
                    alt={currentStudent.name}
                    className="w-16 h-16 rounded-full object-cover border-4 border-primary/20"
                  />
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full flex items-center justify-center">
                    <Icon name="Check" size={12} color="white" strokeWidth={2} />
                  </div>
                </div>*/}
                <div>
                  <h3 className="text-2xl font-bold text-text-primary">{currentStudent.name}</h3>
                  
                  <p className="text-primary font-semibold">{currentStudent.course}</p>
                </div>
              </div>

              

              {/* Testimonial */}
              <div className="mb-6">
                <Icon name="Quote" size={24} className="text-primary mb-3" strokeWidth={2} />
                <p className="text-text-secondary leading-relaxed italic">
                  "{currentStudent.testimonial}"
                </p>
              </div>

              {/* Skills & Projects */}
              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-text-primary mb-2 flex items-center">
                    <Icon name="Code" size={16} className="mr-2" strokeWidth={2} />
                    Skills Mastered
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {currentStudent.skills.map((skill, idx) => (
                      <span
                        key={idx}
                        className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full font-medium"
                      >
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="font-semibold text-text-primary mb-2 flex items-center">
                    <Icon name="Folder" size={16} className="mr-2" strokeWidth={2} />
                    Key Projects
                  </h4>
                  <ul className="space-y-1">
                    {currentStudent.projects.map((project, idx) => (
                      <li key={idx} className="flex items-center space-x-2 text-sm text-text-secondary">
                        <Icon name="CheckCircle" size={14} className="text-success" strokeWidth={2} />
                        <span>{project}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Visual Side */}
            <div className="relative bg-gradient-to-br from-primary/10 to-secondary/10 p-8 lg:p-12 flex flex-col justify-center">
              <div className="relative mb-6">
                <div className="relative overflow-hidden rounded-2xl shadow-xl">
              {isPlaying ? (
    <video
      src={currentStudent.videoUrl}
      controls
      autoPlay
      muted
      className="w-full h-auto rounded-2xl"
      onEnded={() => setIsPlaying(false)}
    />
  ) : (
    <>
      <Image
        src={currentStudent.videoThumbnail}
        alt={`${currentStudent.name} Success Story`}
        className="w-full h-auto object-cover rounded-2xl"
      />
      <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
        <button
          onClick={() => setIsPlaying(true)}
          className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors duration-300"
        >
          <Icon
            name="Play"
            size={24}
            className="text-primary ml-1"
            strokeWidth={2}
          />
        </button>
      </div>
    </>
  )}
</div>

                {/*<div className="absolute -top-4 -right-4 bg-white rounded-xl p-3 shadow-lg">
                  <div className="flex items-center space-x-2">
                    <Image
                      src={currentStudent.companyLogo}
                      alt={currentStudent.company}
                      className="w-8 h-8 rounded object-cover"
                    />
                    <span className="text-sm font-semibold text-text-primary">{currentStudent.company}</span>
                  </div>
                </div>*/}
              </div>

              {/* Timeline */}
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4">
                <h4 className="font-semibold text-text-primary mb-3 flex items-center">
                  <Icon name="Clock" size={16} className="mr-2" strokeWidth={2} />
                  Success Timeline
                </h4>
                <div className="text-sm text-text-secondary">
                  {currentStudent.timeline}
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Story Navigation */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 20 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex flex-wrap justify-center gap-4 mb-12"
        >
          {successStories.map((story, index) => (
            <button
              key={story.id}
              onClick={() => handleStoryChange(index)}
              className={`flex items-center space-x-3 p-4 rounded-xl transition-all duration-300 ${
                currentStory === index
                  ? 'bg-primary text-white shadow-lg scale-105'
                  : 'bg-white text-text-secondary hover:bg-muted border border-border'
              }`}
            >
              {/*<Image
                src={story.avatar}
                alt={story.name}
                className="w-10 h-10 rounded-full object-cover"
              />*/}
              <div className="text-left">
                <div className="font-semibold text-sm">{story.name}</div>
                <div className="text-xs opacity-75">{story.afterRole}</div>
              </div>
            </button>
          ))}
        </motion.div>

         {/* Success Statistics 
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 text-white"
        >
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-2">Our Students' Success by Numbers</h3>
            <p className="opacity-90">Real outcomes from real students who transformed their careers</p>
          </div>
          
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">94%</div>
              <div className="text-sm opacity-90">Placement Success Rate</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">185%</div>
              <div className="text-sm opacity-90">Average Salary Increase</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">2000+</div>
              <div className="text-sm opacity-90">Students Placed</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">50+</div>
              <div className="text-sm opacity-90">Partner Companies</div>
            </div>
          </div>
        </motion.div>*/}

        {/* CTA 
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 30 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="text-center mt-16"
        >
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-border">
            <Icon name="Target" size={48} className="mx-auto mb-4 text-primary" strokeWidth={2} />
            <h3 className="text-2xl font-bold text-text-primary mb-4">Ready to Write Your Success Story?</h3>
            <p className="text-lg text-text-secondary mb-6 max-w-2xl mx-auto">
              Join thousands of students who have successfully transformed their careers through our industry-focused programs.
            </p>
            <button
              onClick={() => {
                const element = document.getElementById('apply-section');
                if (element) {
                  const headerHeight = 80;
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
                  window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
              }}
              className="bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-primary/90 transition-colors duration-300 inline-flex items-center space-x-2"
            >
              <Icon name="Rocket" size={20} strokeWidth={2} />
              <span>Start Your Transformation</span>
            </button>
          </div>
        </motion.div>*/}
      </div>
    </section>
  );
};

export default SuccessStoriesSection;
